import { BaseCell } from '../models';
import { CardListCell } from 'src/app/components/pages-partials/card-list/card-list-cell';
import { Injectable } from '@angular/core';
import { CellParserFactoryService } from './cell-parser-factory.service';

@Injectable({ providedIn: 'root' })
export class DynamicTableCellsParserService {
  constructor(private cellParserFactoryService: CellParserFactoryService) {}

  parse(cells: BaseCell[]): CardListCell[] {
      return cells.map((cell) => {
   
      let parser = this.cellParserFactoryService.getParser(cell.type);

      return parser.parse(cell);
    });
  }
}
